import type { FunctionComponent } from 'react';
import { PerksList } from '../interfaces';
import PerkItem from '../PerkItem/PerkItem';
import * as styles from './PerksListContainer.module.scss';

export interface PerksProps {
  perksList: PerksList;
}

const PerksListContainer: FunctionComponent<PerksProps> = ({ perksList }) => {
  const renderList = perksList && perksList.length;
  return (
    <ul className={styles.plansPerksList}>
      {renderList &&
        perksList.map((perk) => (
          <PerkItem
            key={`${perk.id}-${perk.perk}`}
            perk={perk.perk}
            included={perk.included}
            tooltip={perk.tooltip}
          />
        ))}
    </ul>
  );
};

export default PerksListContainer;
